import { InjectionToken } from '@angular/core';
export var EnablePersistenceToken = new InjectionToken('EnablePersistenceToken');
//# sourceMappingURL=enable-persistance-token.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angularfire2/firestore/enable-persistance-token.js
// module id = ./node_modules/angularfire2/firestore/enable-persistance-token.js
// module chunks = vendor